"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![AddIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+QWRkPC90aXRsZT4KICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04LjUsMEE4LjUsOC41LDAsMSwwLDE3LDguNSw4LjUxLDguNTEsMCwwLDAsOC41LDBabTAsMTZBNy41LDcuNSwwLDEsMSwxNiw4LjUsNy41LDcuNSwwLDAsMSw4LjUsMTZaIi8+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuMjUsNy43NWgtNHYtNGEuNzUuNzUsMCwwLDAtMS41LDB2NGgtNGEuNzUuNzUsMCwwLDAsMCwxLjVoNHY0YS43NS43NSwwLDAsMCwxLjUsMHYtNGg0YS43NS43NSwwLDAsMCwwLTEuNVoiLz4KPC9zdmc+Cg==)
 */
exports.AddIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 17 17", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M8.5 0A8.5 8.5 0 1 0 17 8.5 8.51 8.51 0 0 0 8.5 0zm0 16A7.5 7.5 0 1 1 16 8.5 7.5 7.5 0 0 1 8.5 16z" }),
        React.createElement("path", { d: "M13.25 7.75h-4v-4a.75.75 0 0 0-1.5 0v4h-4a.75.75 0 0 0 0 1.5h4v4a.75.75 0 0 0 1.5 0v-4h4a.75.75 0 0 0 0-1.5z" })));
};
//# sourceMappingURL=Icon.Add.js.map